function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v10H0V5Z",
    style: {
      fill: "#cc092f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.029,11.86h1.221l.37-1.151.38,1.151h1.221l-.981.731.38,1.171-1.001-.711-.991.711.38-1.171-.979-.731Z",
    style: {
      fill: "#ffcb00",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.493,18.157l-.961-.751c.971-.791,1.602-2.002,1.602-3.354,0-2.062-1.471-3.794-3.414-4.205l.15-.701c.27.06.587.174.848.264l.25-.42c.27.13.571.26.821.42l-.19.451c.25.16.552.408.721.604l.376-.294c.2.22.441.45.611.691l-.34.35c.22.323.305.471.467.843l.478-.112c.09.28.227.623.277.914l-.452.178c.054.226.124.62.119.951,0,.02-.002.043-.002.063l.472.067c-.02.29-.03.621-.09.911h-.49c-.07.3-.16.667-.27.947l.41.24c-.13.26-.26.571-.43.821l-.45-.19c-.17.25-.36.49-.571.711l.29.38c-.081.07-.151.141-.232.221M15.381,18.067l.726.437c-.068.062-.27.167-.324.188l.119.456c-.28.09-.581.22-.891.28l-.18-.45c-.29.06-.581.1-.881.1l-.06.471c-.28-.02-.621,0-.931-.07v-.47c-.28-.05-.551-.12-.811-.21l-.23.411c-.24-.1-.561-.221-.821-.381l.17-.45c-.21-.11-.401-.25-.581-.391l.451-.571c.741.591,1.672.941,2.693.941.54-.001,1.071-.091,1.551-.291",
    style: {
      fill: "#ffcb00",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.406,19.227l-4.791-3.646-.044.062,4.779,3.652-.284.355-4.658-2.988c-1.261-.791-1.211-1.411-.951-2.082l.22-.541c.12.701.841,1.231,1.592,1.822l4.23,3.25-.093.116ZM19.609,20.314c-.041,0-.074-.033-.074-.074h0c0-.041.033-.074.074-.074h0c.041,0,.075.033.075.074,0,.04-.033.074-.075.074h0M19.323,20.103c-.041,0-.074-.033-.075-.074,0-.041.033-.075.074-.075s.075.033.075.075c0,.041-.033.074-.074.074h0M19.03,19.87c-.041,0-.075-.033-.075-.074,0-.041.036-.074.077-.072.039,0,.071.033.072.072,0,.041-.033.074-.074.074M20.015,20.283l-1.435-1.112-.417.538,1.247.875c.1.07.11.391.48.441.15.02.25-.09.25-.09.161-.198.117-.468-.125-.652",
    style: {
      fill: "#ffcb00",
      fillRule: "evenodd"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAo);
export default __webpack_public_path__ + "static/media/AO.21637e0b350e5f5ea5904a0eed60e175.svg";
export { ForwardRef as ReactComponent };